import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import OfferForm from '../components/OfferForm';

const PHONE = "05513683020";
const PHONE_DISPLAY = "0551 368 30 20";

const HomePage = () => {
  const [serviceImages, setServiceImages] = useState({});
  const [services, setServices] = useState([]);
  const [completedProjects, setCompletedProjects] = useState([]);
  const [fonImages, setFonImages] = useState([]);
  const [heroImage, setHeroImage] = useState(null);

  useEffect(() => {
    const klasorler = [
      "audio", "aydinlatma", "boyler", "elektrik-ariza", "ev-elektrik",
      "guvenlik-kamera", "isyeri-elektrik", "klima", "tadilat"
    ];

    fetch("/image_json/services_meta.json")
      .then((res) => res.json())
      .then((metaData) => {
        Promise.all(
          klasorler.map((slug) =>
            fetch(`/image_json/${slug}.json`)
              .then((res) => res.json())
              .then((data) => {
                setServiceImages((prev) => ({ ...prev, [slug]: data }));
                const meta = metaData[slug] || {};
                return {
                  id: slug,
                  title: meta.title || slug,
                  description: meta.full_desc || "",
                  short_desc: meta.short_desc || "",
                  icon: meta.icon || "default.png",
                  category: slug,
                };
              })
              .catch(() => ({
                id: slug,
                title: slug,
                description: "",
                short_desc: "",
                icon: "default.png",
                category: slug,
              }))
          )
        ).then((serviceList) => {
          setServices(serviceList);
        });
      });
  }, []);

  useEffect(() => {
    fetch("/image_json/fon.json")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setFonImages(data);
          setHeroImage(data[0]);
        } else {
          console.warn("fon.json boş veya geçersiz");
        }
      })
      .catch((err) => console.error("fon.json yüklenemedi:", err));
  }, []);

  useEffect(() => {
    fetch("/image_json/projeler.json")
      .then((res) => res.json())
      .then((data) => setCompletedProjects(data))
      .catch((err) => console.error("projeler.json yüklenemedi:", err));
  }, []);

  const handleCallClick = () => {
    window.location.href = `tel:${PHONE}`;
  };

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/9${PHONE}`, "_blank");
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // ✅ Google Maps bileşeni
  const MapSection = () => (
  <div
    style={{
      maxWidth: "900px",        // kartın genişliğini sınırlıyoruz
      margin: "2rem auto",      // ortalıyoruz
      padding: "1rem",          // iç boşluk
      backgroundColor: "#fff",  // beyaz arka plan
      borderRadius: "12px",     // yuvarlatılmış köşeler
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)", // modern gölge
    }}
  >
    <iframe
      title="Google Maps"
      src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d185.66196202082028!2d32.79146247474535!3d39.959371172051966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1str!2str!4v1767375302171!5m2!1str!2str" 
      width="100%"
      height="450"
      style={{
        border: 0,
        borderRadius: "8px", // iframe köşelerini de hafif yuvarlat
      }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
    );






  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <img src="/logo.png" alt="Logo" className="h-12 w-auto" />
              <div>
                <h1 className="text-xl md:text-2xl font-bold text-blue-900">Ankara Elektrik Uzmanı</h1>
                <p className="text-xs text-gray-600 hidden md:block">Klima & Elektrik Hizmetleri</p>
              </div>
            </div>
            <nav className="hidden lg:flex space-x-6">
              <button onClick={() => scrollToSection("hizmetler")} className="text-gray-700 hover:text-blue-900 font-medium transition">Hizmetlerimiz</button>
              <button onClick={() => scrollToSection("neden-biz")} className="text-gray-700 hover:text-blue-900 font-medium transition">Neden Biz</button>
              <button onClick={() => scrollToSection("projeler")} className="text-gray-700 hover:text-blue-900 font-medium transition">Projelerimiz</button>
              <button onClick={() => scrollToSection("iletisim")} className="text-gray-700 hover:text-blue-900 font-medium transition">İletişim</button>
              <button onClick={() => scrollToSection("Konum")} className="text-gray-700 hover:text-blue-900 font-medium transition">Konum</button>
            </nav>
            <a href={`tel:${PHONE}`} className="bg-yellow-400 text-blue-900 px-4 py-2 rounded-lg font-semibold hover:bg-yellow-500 transition flex items-center space-x-2">
              <span>📞</span>
              <span className="hidden sm:inline">{PHONE_DISPLAY}</span>
            </a>
          </div>
          <nav className="lg:hidden flex justify-around mt-3 border-t pt-3">
            <button onClick={() => scrollToSection("hizmetler")} className="text-sm text-gray-700 hover:text-blue-900">Hizmetler</button>
            <button onClick={() => scrollToSection("neden-biz")} className="text-sm text-gray-700 hover:text-blue-900">Neden Biz</button>
            <button onClick={() => scrollToSection("projeler")} className="text-sm text-gray-700 hover:text-blue-900">Projeler</button>
            <button onClick={() => scrollToSection("iletisim")} className="text-sm text-gray-700 hover:text-blue-900">İletişim</button>
            <button onClick={() => scrollToSection("Konum")} className="text-gray-700 hover:text-blue-900 font-medium transition">Konum</button>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section
        className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-16 md:py-24"
        style={{
          backgroundImage: heroImage
            ? `linear-gradient(rgba(30, 58, 138, 0.9), rgba(30, 64, 175, 0.9)), url('${heroImage}')`
            : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-5xl font-bold mb-4">Ankara'nın Güvenilir Elektrik Ustası</h2>
          <p className="text-lg md:text-xl mb-2 text-gray-200">⚡ Elektrik Arıza Tamiri | ❄️ Klima Montaj & Bakım | 💡 Aydınlatma Sistemleri</p>
          <p className="text-base md:text-lg mb-8 text-gray-300">7/24 Profesyonel Hizmet | Hızlı, Güvenli ve Uygun Fiyatlı Çözümler</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button onClick={handleCallClick} className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-500 transition flex items-center justify-center space-x-2">
              <span>📞</span>
              <span>Hemen Ara</span>
            </button>
            <button onClick={handleWhatsAppClick} className="bg-green-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-green-600 transition flex items-center justify-center space-x-2">
              <span>💬</span>
              <span>WhatsApp</span>
            </button>
          </div>
        </div>
      </section>


      {/* Services Section */}
      <section id="hizmetler" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Hizmetlerimiz
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Ankara genelinde tüm elektrik, klima ve aydınlatma hizmetleriniz için profesyonel çözümler
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service) => (
              <Link
                key={service.id}
                to={`/hizmet/${service.id}`}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-blue-500 hover:-translate-y-1 cursor-pointer"
              >
                <div className="flex items-center space-x-3 mb-4">
                  <span className="text-3xl">{service.icon}</span>
                  <h4 className="text-xl font-bold text-gray-800">{service.title}</h4>
                </div>
                <p className="text-gray-600">{service.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>      
      {/* Why Choose Us Section */}
      <section id="neden-biz" className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Neden Bizi Seçmelisiniz?
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-xl p-6 text-center shadow-md">
              <div className="text-5xl mb-4">⚡</div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">Hızlı Hizmet</h4>
              <p className="text-gray-600">7/24 acil müdahale ve aynı gün hizmet garantisi</p>
            </div>

            <div className="bg-white rounded-xl p-6 text-center shadow-md">
              <div className="text-5xl mb-4">👨‍🔧</div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">Uzman Ekip</h4>
              <p className="text-gray-600">10+ yıl tecrübeli ve sertifikalı elektrik ustaları</p>
            </div>

            <div className="bg-white rounded-xl p-6 text-center shadow-md">
              <div className="text-5xl mb-4">💰</div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">Uygun Fiyat</h4>
              <p className="text-gray-600">Şeffaf fiyatlandırma, gizli maliyet yok</p>
            </div>

            <div className="bg-white rounded-xl p-6 text-center shadow-md">
              <div className="text-5xl mb-4">✅</div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">Garanti</h4>
              <p className="text-gray-600">Tüm işlerimizde 1 yıl garanti</p>
            </div>
          </div>
        </div>
      </section>
      {/* Teklif Formu */}
      <section id="teklif" className="py-16 bg-gradient-to-r from-blue-900 to-blue-700">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-2xl p-8">
                        <div className="text-center mb-8">
              <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Ücretsiz Teklif Alın
              </h3>
              <p className="text-gray-600">
                Bilgilerinizi bırakın, size en kısa sürede dönelim
              </p>
            </div>
            <OfferForm services={services} />
          </div>
        </div>
      </section>

      {/* Completed Projects Section */}
      <section id="projeler" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Bitirilen Projeler
            </h3>
            <p className="text-gray-600">
              Başarıyla tamamladığımız projelerden örnekler
            </p>
          </div>

          <div className="overflow-x-auto">
            <div className="flex space-x-6 pb-4">
              {completedProjects.map((project, index) => {
                const imageUrl = typeof project === "string" ? project : project.url;
                const altText = project.title || `Proje ${index + 1}`;
                return (
                  <div key={index} className="flex-shrink-0 w-80 h-60 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition">
                    <img
                      src={imageUrl}
                      alt={altText}
                      className="w-full h-full object-cover hover:scale-110 transition duration-300"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="iletisim" className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              İletişim
            </h3>
          </div>

          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-xl p-8 shadow-md">
              <h4 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                İletişim Bilgileri
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-center space-x-3">
                  <span className="text-3xl">📞</span>
                  <div>
                    <p className="text-gray-600 text-sm">Telefon</p>
                    <a
                      href={`tel:${PHONE}`}
                      className="text-blue-900 font-bold text-lg hover:underline"
                    >
                      {PHONE_DISPLAY}
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <span className="text-3xl">💬</span>
                  <div>
                    <p className="text-gray-600 text-sm">WhatsApp</p>
                    <a
                      href={`https://wa.me/9${PHONE}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-900 font-bold text-lg hover:underline"
                    >
                      {PHONE_DISPLAY}
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <span className="text-3xl">📧</span>
                  <div>
                    <p className="text-gray-600 text-sm">E-posta</p>
                    <a
                      href="mailto:info@elektrikuzmanı.com"
                      className="text-blue-900 font-bold text-lg hover:underline"
                    >
                      info@elektrikuzmanı.com
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <span className="text-3xl">📍</span>
                  <div>
                    <p className="text-gray-600 text-sm">Bölge</p>
                    <p className="text-blue-900 font-bold text-lg">Ankara</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-4 bg-yellow-100 rounded-lg border border-yellow-300">
                <p className="text-yellow-800 font-semibold text-center text-lg">
                  ⚡ Acil Durumlarda 7/24 Hizmet
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* harita konumu */}
      <section id="Konum" className="py-16 bg-gray-100">
        <div className="container mx-auto px-1">
          <div className="text-center mb-1">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-1">
              Konum
            </h3>
          </div>
          <MapSection />
        </div>
      </section>
      
      
      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <div className="mb-4">
            <img
              src="/logo.png"
              alt="Logo"
              className="h-16 w-auto mx-auto mb-2"
            />
            <h5 className="text-xl font-bold">Ankara Elektrik Uzmanı</h5>
          </div>
          <p className="text-gray-400 mb-2">
            📞 {PHONE_DISPLAY} | 📧 info@elektrikuzmanı.com
          </p>
          <p className="text-gray-500 text-sm mt-4">
            © 2025 Ankara Elektrik Uzmanı. Tüm hakları saklıdır.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;


      
      